import { ContentFull, ContentHeader } from "components/layout";
import { Select } from "components/ui/select";
import { Toggle } from "components/ui/toggle";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentUser, useNewLayout } from "store/selectors/hooks";
import { designSlice } from "store/slices/design";
import { ApplicationState } from "store/state";
import { inAdvancedMode } from "util/browser";
import { useCommitUserPreference } from "./account-settings-hooks";

export const AccountSettingsGeneral: React.FC<unknown> = () => {
    const user = useCurrentUser();
    const theme = useSelector((state: ApplicationState) => state.design.theme || "light");
    const sidebarMode = useSelector(
        (state: ApplicationState) => state.design.sidebarMode || "default",
    );

    const commitTimezonePref = useCommitUserPreference("timezone");

    const updateTimezone = React.useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            commitTimezonePref(e.target.value);
        },
        [commitTimezonePref],
    );
    const isUseNewDesignChecked = useNewLayout();
    const dispatch = useDispatch();
    const { setPreviewDesign, setTheme, setSidebarMode } = designSlice.actions;
    const handlePreviewChange = React.useCallback(
        (enabled: boolean) => {
            dispatch(setPreviewDesign(enabled ? "new" : "legacy"));
        },
        [dispatch, setPreviewDesign],
    );
    const handleThemeChange = React.useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            dispatch(setTheme(e.target.value as "light" | "dark" | "system"));
        },
        [dispatch, setTheme],
    );
    const handleSidebarModeChange = React.useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            dispatch(
                setSidebarMode(e.target.value as "default" | "hamburgler" | "compact"),
            );
        },
        [dispatch, setSidebarMode],
    );
    return (
        <div className="space-y-4 lg:space-y-8">
            <ContentFull>
                <ContentHeader>General</ContentHeader>
                <div className="space-y-4 max-w-lg">
                    <Select
                        label="Time zone"
                        value={user.preferences.timezone || ""}
                        onChange={updateTimezone}>
                        <option value="">(Unspecified)</option>
                        <option value="America/Anchorage">Alaska</option>
                        <option value="America/Honolulu">Hawaii</option>
                        <option value="America/Los_Angeles">Pacific</option>
                        <option value="America/Denver">Mountain</option>
                        <option value="America/Phoenix">Mountain (no DST)</option>
                        <option value="America/Chicago">Central</option>
                        <option value="America/New_York">Eastern</option>
                        <option value="America/Vancouver">Pacific (Canada)</option>
                        <option value="America/Edmonton">Mountain (Canada)</option>
                        <option value="America/Halifax">Atlantic (Canada)</option>
                        <option value="America/Winnipeg">Central (Canada)</option>
                        <option value="America/Toronto">Eastern (Canada)</option>
                        <option value="America/St_Johns">Newfoundland (Canada)</option>
                    </Select>
                    <Toggle
                        onChange={handlePreviewChange}
                        checked={isUseNewDesignChecked}
                        label="Preview new design"
                    />
                    {inAdvancedMode() && (
                        <Select label="Theme" value={theme} onChange={handleThemeChange}>
                            <option value="light">Light</option>
                            <option value="dark">Dark</option>
                            <option value="system">System</option>
                        </Select>
                    )}
                    {inAdvancedMode() && (
                        <Select
                            label="Sidebar Mode"
                            value={sidebarMode}
                            onChange={handleSidebarModeChange}>
                            <option value="default">Default</option>
                            <option value="hamburgler">Hamburgler</option>
                            <option value="compact">Compact</option>
                        </Select>
                    )}
                </div>
            </ContentFull>
        </div>
    );
};
